module.exports = __webpack_public_path__ + "img/iconLiShiRenLianZhaJi.166a09eb.svg";